import React from 'react';
import { useSelector } from 'react-redux';
import {  Redirect, Route } from 'react-router-dom';
import { paths } from '../../routes';

const PrivateRoute = ({ children, ...rest }) => {
    const user = useSelector(state => state.auth.user);

    return (
        <Route
            {...rest}
            render={({ location }) => {
                if (user?.jwt) {
                    return children
                } else {
                    return (
                        <Redirect
                            to={{
                                pathname: paths.login,
                                state: { from: location }
                            }}
                        />
                    )
                }
            }}
        />
    );
};

export default PrivateRoute;
